import { ReactNode } from 'react'
import { cn } from '@/shared/utils'

interface PageHeaderProps {
  title: string
  subtitle?: string | ReactNode
  actions?: ReactNode
  className?: string
}

export function PageHeader({ title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-8', className)}>
      <div className="flex-1 min-w-0 pr-4">
        <h1 className="break-words text-display-lg text-foreground mb-2">{title}</h1>
        {subtitle && (
          typeof subtitle === 'string' ? (
            <p className="text-body-lg text-earth-600">{subtitle}</p>
          ) : (
            <div>{subtitle}</div>
          )
        )}
      </div>
      {actions && (
        <div className="flex items-center space-x-3 flex-shrink-0">
          {actions}
        </div>
      )}
    </div>
  )
}
